import { render, staticRenderFns } from "./deptSelect.vue?vue&type=template&id=4ed6c51a&"
import script from "./deptSelect.vue?vue&type=script&lang=ts&"
export * from "./deptSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports